/** Prior 2022 CAP electricity from 2024 GGRP status report — superseded by Rincon 2024 memo Table 3. */
export const BURBANK_CAP_2022_ELECTRICITY_SUPERSEDED = {
  year: 2022,
  residentialKwh: 301_971_679,
  commercialKwh: 713_859_924,
  municipalInterdepartmentalKwh: 34_381_008,
  resPlusCommercialKwh: 1_015_831_603,
  resComMunicipalKwh: 1_050_212_611,
  sourceVersion: 'burbank_ggrp_status_report_2024',
  sourceUrl:
    'https://www.burbankca.gov/documents/d/community-development/2024ggrpstatusreport?download=true',
} as const;

/** Current 2022 CAP electricity (Rincon memorandum, Attachment 1 Table 3). */
export const BURBANK_CAP_2022_ELECTRICITY_CURRENT = {
  year: 2022,
  residentialKwh: 289_732_969,
  commercialKwh: 713_274_904,
  municipalInterdepartmentalKwh: 34_352_833,
  resPlusCommercialKwh: 1_003_007_873,
  resComMunicipalKwh: 1_037_360_706,
  sourceVersion: 'rincon_2024_ghg_inventory_update_memo',
  sourceUrl: 'analysis/burbank_cap_2024_inventory_update_20260918/sources/Attachment 1 - GHG Inventory Update 2024 Data.pdf',
  sourceNote:
    'CAP community inventory excludes industrial energy; includes Hollywood Burbank Airport in commercial. Municipal/interdepartmental reported separately.',
} as const;

/** Active comparison anchor — points at current published CAP revision. */
export const BURBANK_CAP_2022_ELECTRICITY = BURBANK_CAP_2022_ELECTRICITY_CURRENT;

/** Legacy ClimatePlans 2022 totals from elec_*_format pipeline (pre-EIA override). */
export const BURBANK_LEGACY_CLIMATEPLANS_2022 = {
  residentialKwh: 254_288_000,
  commercialKwh: 476_624_000,
  totalKwh: 730_912_000,
} as const;

export const BURBANK_EIA_2022_TOTAL_KWH = 978_966_000;

/** Previous ClimatePlans minus BWP/EIA (negative when EIA is higher). */
export const BURBANK_EIA_VS_LEGACY_2022 = {
  totalDeltaKwh: BURBANK_LEGACY_CLIMATEPLANS_2022.totalKwh - BURBANK_EIA_2022_TOTAL_KWH,
  totalDeltaPct:
    ((BURBANK_LEGACY_CLIMATEPLANS_2022.totalKwh - BURBANK_EIA_2022_TOTAL_KWH) /
      BURBANK_EIA_2022_TOTAL_KWH) *
    100,
  commercialDeltaKwh:
    BURBANK_LEGACY_CLIMATEPLANS_2022.commercialKwh - 704_221_000,
} as const;
